import Billing from "@/models/Billing";
import { deepCopyObject } from "@/helpers/deep-copy-object";

/**
 * Converts a form payload into a Billing object.
 * @param {Object} payload - The form payload containing billing data.
 * @param {string} memberId - The ID of the member.
 * @param {string} academyId - The ID of the academy.
 * @returns {Object} A deep copy of the new Billing object.
 */
export function convertFormToBilling(payload, memberId, academyId) {
  // Create a new Billing object with the provided data
  let billing = new Billing({
    date: payload.date, // The date of the billing
    createdAt: new Date(), // The creation date of the billing entry
    reference: payload.reference, // The reference identifier for the billing
    method: payload.method, // The method of payment
    price: payload.price, // The price amount, converted to a number
    academyId: academyId, // The ID of the associated academy
    memberId: memberId, // The ID of the associated member
    description: payload.description, // A description of the billing
  });

  // Return a deep copy of the billing object
  return deepCopyObject(billing);
}
